var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-form',{attrs:{"user":_vm.settingsUser,"showDeleteButton":_vm.showDeleteButton},on:{"delete-user":_vm.onDeleteUser,"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }